import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ColissessionService } from '../../services/colissession/colissession.service';

@Injectable({
  providedIn: 'root'
})
export class SessionGuard{

  result = false;
  private userprivileges: any;
  constructor(private router: Router, private toastService: ToastrService, private sessionservice: ColissessionService) { }

  // canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<boolean> | Promise<boolean> | boolean> {
  //   let session: any = localStorage.getItem('session');


}
